import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { CustomersIndividualsComponentModule } from './controllers/CustomersIndividualsController';
import { CustomersIndividualsDetailComponentModule } from './detail/controllers/CustomersIndividualsDetailController';
import { customersIndividualsDetailView } from './detail/detail';
import { CustomersIndividualsListView } from './list/list';

export const CustomersIndividualsView = angular
  .module('acme.view.application.customers.individuals', [
    uiRouter,
    'ui.bootstrap',
    CustomersIndividualsComponentModule,
    CustomersIndividualsListView,
    customersIndividualsDetailView,
    CustomersIndividualsDetailComponentModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.customers.individuals',
      url: '/individuals',
      views: {
        'subview-main': {
          component: 'acmeCustomersIndividuals',
        },
      },
      data: {
        pageTitle: 'Customers',
        permissions: ['CUSTOMERS_VIEW'],
      },
    });
  }).name;
